import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  labelledBy: string;
  children: React.ReactNode;
}
export function Modal({
  open,
  onClose,
  labelledBy,
  children
}: ModalProps) {
  const {
    t
  } = useLocale();
  return <AnimatePresence data-id="element-1248" data-mp="9d3w1s8ekein">
      {open && <div className="absolute inset-0 z-50 flex items-end justify-center px-4 pb-6" data-id="element-1249" data-mp="9c2ldovatu1g">
          <motion.button type="button" aria-label={t('common.close')} onClick={onClose} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 cursor-default bg-deeper/70" data-id="element-1250" data-mp="4fc6h4v8d4hm" />
          <motion.div role="dialog" aria-modal="true" aria-labelledby={labelledBy} initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full rounded-panel bg-sand p-3 shadow-lift" data-id="element-1251" data-mp="2f5u5mo1q8jk1">
            <button type="button" onClick={onClose} aria-label={t('common.close')} className="absolute right-3 top-3 grid h-11 w-11 place-items-center rounded-pill text-muted transition-colors duration-150 ease-brand hover:text-deep" data-id="element-1252" data-mp="2d2rscfiuw78m">
              <XIcon size={18} data-id="element-1253" data-mp="1pguzelsxve9b" />
            </button>
            {children}
          </motion.div>
        </div>}
    </AnimatePresence>;
}